// extracted by mini-css-extract-plugin
export default {"advertising__wrapper":"advertising_advertising__wrapper__vx7XS","advertising__text":"advertising_advertising__text__Za4la","infoClose":"advertising_infoClose__tckX6"};